import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeDuplicateFieldConfirmSchema, setFieldAndValidate } from '../../../utils/field-utils';
import PasswordWithLabelV2 from '../../../components/composite/FormSets/PasswordWithLabelV2/PasswordWithLabelV2';
import InputWithLabelV2 from '../../../components/composite/FormSets/InputWithLabelV2/InputWithLabelV2';
import { validatePassword } from '../../../../shared-with-server/validation-utils';
import { userFieldSchemas } from '../../../utils/validation-utils';

const PasswordAndConfirmPasswordControlSet = ({
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  isRealPassword,
  setIsRealPassword,
  changeHandlers,
}) => {
  const confirmPasswordSchema = makeDuplicateFieldConfirmSchema(password, 'Password');

  useEffect(
    () => {
      if (password.state === 2 && confirmPassword.state === 2) {
        setFieldAndValidate(confirmPassword, setConfirmPassword, confirmPassword.value, confirmPasswordSchema);
      }
    },
    [password],
  );

  const passwordChangeHandler = (value) => {
    if (!isRealPassword) {
      if (value.length > 1) {
        setFieldAndValidate(password, setPassword, '', userFieldSchemas.password);
      } else {
        setFieldAndValidate(password, setPassword, value, userFieldSchemas.password);
      }

      setIsRealPassword(true);
    } else {
      setFieldAndValidate(password, setPassword, value, userFieldSchemas.password);
    }
  };

  const confirmPasswordChangeHandler = (value) => {
    setFieldAndValidate(confirmPassword, setConfirmPassword, value, confirmPasswordSchema);
  };

  useEffect(
    () => {
      changeHandlers.password = passwordChangeHandler;
      changeHandlers.confirmPassword = confirmPasswordChangeHandler;
    },
    [password, setPassword, confirmPassword, setConfirmPassword, isRealPassword, setIsRealPassword],
  );

  return (
    <>
      {/* Password */}
      <PasswordWithLabelV2
        id="password"
        label="Create a Password"
        autoComplete="new-password"
        value={password.value}
        maxLength={72}
        errorMsg={password.error}
        validity={validatePassword(password.value)}
        onChange={({ target: { value } }) => passwordChangeHandler(value)}
        selectAllOnFocus={!isRealPassword}
      />

      {/* Confirm Password */}
      <InputWithLabelV2
        id="confirmPassword"
        label="Confirm Password"
        type="password"
        autoComplete="new-password"
        value={confirmPassword.value}
        isRealPassword={isRealPassword}
        maxLength="72"
        errorMsg={confirmPassword.error}
        onChange={({ target: { value } }) => confirmPasswordChangeHandler(value)}
        selectAllOnFocus={!isRealPassword}
      />
    </>
  );
};

PasswordAndConfirmPasswordControlSet.propTypes = {
  password: PropTypes.object.isRequired,
  setPassword: PropTypes.func.isRequired,
  confirmPassword: PropTypes.object.isRequired,
  setConfirmPassword: PropTypes.func.isRequired,
  isRealPassword: PropTypes.bool.isRequired,
  setIsRealPassword: PropTypes.func.isRequired,
  changeHandlers: PropTypes.shape({
    password: PropTypes.func,
    confirmPassword: PropTypes.func,
  }).isRequired,
};

export default PasswordAndConfirmPasswordControlSet;
